import React from 'react';
import { Facebook, Youtube, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <>
      {/* Yellow separator line between dark section and footer */}
      <div className="w-full h-1 bg-kiloterra-yellow"></div>
      
      <footer className="bg-white text-kiloterra-dark py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Company Info - Centered */}
          <div className="text-center">
            <a 
              href="https://www.kiloterra.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center mb-4 hover:opacity-80 transition-opacity"
            >
              <img 
                src="/kiloterra_logo_simple_white.png" 
                alt="KILOTERRA Logo" 
                className="h-8 w-auto brightness-0"
              />
            </a>
            <p className="text-kiloterra-dark opacity-70 mb-6 max-w-md mx-auto">
              We believe a life connected to the land, is one better lived.
            </p>
            <div className="flex justify-center space-x-4">
              <a 
                href="https://www.facebook.com/KILOTERRA.Land.Co/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-kiloterra-dark opacity-60 hover:text-kiloterra-yellow transition-colors"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a 
                href="https://www.youtube.com/@KILOTERRA" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-kiloterra-dark opacity-60 hover:text-kiloterra-yellow transition-colors"
              >
                <Youtube className="h-5 w-5" />
              </a>
              <a 
                href="https://www.instagram.com/kiloterra.land.company/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-kiloterra-dark opacity-60 hover:text-kiloterra-yellow transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div className="mt-8 pt-8 text-center border-t border-gray-200">
            <p className="text-kiloterra-dark mb-2 uppercase font-medium">
              © 2026 KILOTERRA | ALL RIGHTS RESERVED.
            </p>
            <p className="text-kiloterra-dark opacity-60 text-sm uppercase mb-1">
              KILOTERRA is licensed in Iowa, Missouri, Nebraska & Kansas.
            </p>
            <p className="text-kiloterra-dark opacity-60 text-sm">
              22287 Old Hwy 6, Adel, Iowa 50003
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;